import { RefObject, useEffect } from 'react'
import { duration } from '@mui/material'

type ScollToItemProps = {
  ref: RefObject<HTMLDivElement>
  isScroll: boolean
}

type ReturnScrollToItem = {
  scrollToItem: () => void
}

export const useScrollToItem = ({ isScroll, ref }: ScollToItemProps): ReturnScrollToItem => {
  const scrollToItem = () => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }

  useEffect(() => {
    if (isScroll) {
      setTimeout(() => scrollToItem(), duration.shorter)
    }
  }, [isScroll, ref.current])

  return { scrollToItem }
}
